import { DASAMSA_FORM_HEADING } from "./_form-heading";

// The D10 birth-form card's controls, shared by the deferred shell and the
// island so the server-rendered shell reads exactly like the form that
// replaces it (submit), plus the errors and the result reserve's status and
// edit label. Hindi is Devanagari (owner decision 2026-10-28, replacing the
// 2026-10-08 Hinglish rule); tests/hindi-register.test.ts guards the hi block
// (Devanagari) and the en block (no Devanagari). The
// card's heading is indexed page copy, Devanagari on /hi/ (owner, 2026-10-08),
// so it lives in ./_form-heading.ts.
export const DASAMSA_FORM_COPY = {
  en: {
    submit: "Generate Dasamsa chart",
    errorFallback: "Something went wrong. Please try again.",
    calculating: "Calculating your D10 chart…",
    editDetails: "Edit birth details",
    timeRequired: "Exact birth time is required to calculate D10 houses.",
    placeRequired: "Select a birth city from the suggestions to calculate its coordinates.",
    timeRequiredHint: "The D10 Lagna changes about every 12 minutes — accurate time is essential.",
  },
  hi: {
    submit: "दशमांश चार्ट बनाएँ",
    errorFallback: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
    calculating: "आपके D10 चार्ट की गणना हो रही है…",
    editDetails: "जन्म विवरण बदलें",
    timeRequired: "D10 भावों के लिए सही जन्म समय ज़रूरी है।",
    placeRequired: "सटीक निर्देशांक के लिए सुझावों में से जन्म स्थान चुनें।",
    timeRequiredHint: "D10 लग्न लगभग हर 12 मिनट में बदलता है — सही समय ज़रूरी है।",
  },
} as const;

/** Props the island passes to BirthDetailsForm, mirrored by BirthToolFormShell. */
export function dasamsaFormShellProps(language: "en" | "hi") {
  const copy = DASAMSA_FORM_COPY[language];
  return {
    language,
    heading: DASAMSA_FORM_HEADING[language],
    submitLabel: copy.submit,
    collectName: false,
    requireBirthTime: true,
    showTrustStrip: true,
    timeRequiredHint: copy.timeRequiredHint,
  } as const;
}
